import { render, staticRenderFns } from "./TButton.vue?vue&type=template&id=6e1376da&scoped=true&"
import script from "./TButton.vue?vue&type=script&lang=js&"
export * from "./TButton.vue?vue&type=script&lang=js&"
import style0 from "./TButton.vue?vue&type=style&index=0&id=6e1376da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1376da",
  null
  
)

/* custom blocks */
import block0 from "./TButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports